import VueLib from 'vue'
import * as Sentry from '@sentry/browser'
import { Dedupe, ExtraErrorData, ReportingObserver, RewriteFrames, Vue } from '@sentry/integrations'

export default function (ctx, inject) {
  const opts = Object.assign({}, {"dsn":"https:\u002F\u002F06d0c1f863a642bcb7ff77f7c927edf5@sentry.io\u002F4345457","environment":"production","release":"0.0.2","ignoreErrors":["ReportingObserver [deprecation]: Synchronous XMLHttpRequest on the main thread is deprecated","ReportingObserver [intervention]: Ignored attempt to cancel a touchmove event with cancelable=false","ReportingObserver [intervention]: Modified page load behavior on the page because the page was expected to take a long amount of time to load"]}, {
    integrations: [
      new Dedupe({}),
      new ExtraErrorData({}),
      new ReportingObserver({}),
      new RewriteFrames({}),
      new Vue({Vue: VueLib, ...{"attachProps":true}})
    ]
  })

  // Initialize sentry
  Sentry.init(opts)

  // Inject Sentry to the context as $sentry
  inject('sentry', Sentry)
  ctx.$sentry = Sentry
}
